import React from "react";
import DialogForm from "../DialogForm";
import {Col, Grid} from "../Grid";
import T from "../../utils/T";
import TextField from "../TextField";

export default function RemoveTOTPForm(props) {
    return(
        <DialogForm
            width='1/2'
            title={`Remove Two Factor Authentication`}
            method='POST'
            {...props}
        >
            <Grid gap={5} justify={'center'}>
                <Col size={16} className='font-bold'>
                    <p><T>In order to remove Two Factor Authentication, please follow these steps</T>:</p>
                </Col>
                <Col size={16}>
                    <p><T>With your authentication app or recovery code, please insert a verification code to ensure it's you</T>:</p>
                </Col>
                <Col>
                </Col>
            </Grid>
            <Col size={12}>
                <TextField
                    label='Verification Code'
                    field='code'
                    required
                />
            </Col>
        </DialogForm>
    );
}